/* =====================================================================
   Bluewud wishlist UI — hearts on product cards + product page, and the
   /pages/wishlist renderer. All state lives in BWSaved (bluewud-saved-items.js).
   Injection-only: no existing snippet/section markup is edited, so removing
   this file removes the feature cleanly.
   ===================================================================== */
(function () {
  'use strict';

  if (window.BWWishlistUI) return;

  var HEART_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.7 4.9 13.6a4.7 4.7 0 0 1 0-6.7 4.8 4.8 0 0 1 6.7 0l.4.4.4-.4a4.8 4.8 0 0 1 6.7 0 4.7 4.7 0 0 1 0 6.7Z"/></svg>';

  function saved() { return window.BWSaved; }

  function handleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function formatMoney(cents) {
    var n = parseFloat(cents) / 100;
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: 'INR', maximumFractionDigits: 0
      }).format(n);
    } catch (err) {
      return 'Rs. ' + Math.round(n);
    }
  }

  /* ---- Hearts on product cards ---------------------------------------- */
  function makeHeart(handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bw-wish-heart';
    btn.innerHTML = HEART_SVG;
    syncHeart(btn, handle);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (saved().has('wishlist', handle)) {
        saved().remove('wishlist', handle);
      } else {
        saved().add({ handle: handle, source: 'wishlist' });
      }
      syncHeart(btn, handle);
    });
    return btn;
  }

  function syncHeart(btn, handle) {
    var active = saved().has('wishlist', handle);
    btn.classList.toggle('bw-wish-heart--active', active);
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function injectCardHearts(scope) {
    (scope || document).querySelectorAll('.productitem').forEach(function (item) {
      if (item.querySelector('.bw-wish-heart')) return;
      var link = item.querySelector('a[href*="/products/"]');
      var handle = handleFromUrl(link && link.getAttribute('href'));
      if (!handle) return;
      if (getComputedStyle(item).position === 'static') item.style.position = 'relative';
      item.appendChild(makeHeart(handle));
    });
  }

  /* Cards can arrive late (sliders, SKU promotion, quick views). */
  function watchForCards() {
    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (!pending) {
            pending = true;
            requestAnimationFrame(function () { pending = false; injectCardHearts(); });
          }
          break;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---- Product page buttons ---------------------------------------------
     The Wishlist + Share pair is rendered (hidden) by snippets/product.liquid
     inside the buy box so alignment is Liquid-owned; this only wires them up
     and reveals them. If either script fails, no dead buttons appear. */
  function initPdpButtons() {
    var handle = handleFromUrl(window.location.pathname);
    if (!handle) return;

    var wishBtn = document.querySelector('[data-bw-wish-pdp]');
    if (wishBtn && !wishBtn.__bwBound) {
      wishBtn.__bwBound = true;
      var syncLabel = function () {
        var active = saved().has('wishlist', handle);
        wishBtn.classList.toggle('bw-wish-pdp--active', active);
        wishBtn.innerHTML = HEART_SVG + '<span>' +
          (active ? 'Saved in Wishlist' : 'Add to Wishlist') + '</span>';
      };
      syncLabel();
      wishBtn.addEventListener('click', function () {
        if (saved().has('wishlist', handle)) saved().remove('wishlist', handle);
        else saved().add({ handle: handle, source: 'wishlist' });
        syncLabel();
      });
      wishBtn.hidden = false;
    }

    var shareBtn = document.querySelector('[data-bw-share-pdp]');
    if (shareBtn && !shareBtn.__bwBound) {
      shareBtn.__bwBound = true;
      var shareLabel = shareBtn.querySelector('span');
      shareBtn.addEventListener('click', function () {
        var url = window.location.origin + window.location.pathname;
        var confirmCopied = function () {
          if (!shareLabel) return;
          shareLabel.textContent = 'Link copied ✓';
          setTimeout(function () { shareLabel.textContent = 'Share'; }, 2200);
        };
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(confirmCopied, function () {
            window.prompt('Copy this product link:', url);
          });
        } else {
          window.prompt('Copy this product link:', url);
        }
      });
      shareBtn.hidden = false;
    }
  }

  /* ---- Wishlist page ----------------------------------------------------
     Product data is always fetched fresh (/products/<handle>.js) so prices
     and stock are live; only handles are stored. A 404 (product deleted)
     silently removes the entry. */
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 404) { saved().remove('wishlist', handle); return null; }
        return r.ok ? r.json() : null;
      })
      .catch(function () { return null; });
  }

  function buildWishCard(product, handle) {
    var card = document.createElement('div');
    card.className = 'bw-wish-card';

    var link = document.createElement('a');
    link.className = 'bw-wish-card__media';
    link.href = product.url;
    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image + (product.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=360';
      img.alt = product.title;
      img.loading = 'lazy';
      link.appendChild(img);
    }
    card.appendChild(link);

    var body = document.createElement('div');
    body.className = 'bw-wish-card__body';

    var title = document.createElement('a');
    title.className = 'bw-wish-card__title';
    title.href = product.url;
    title.textContent = product.title;
    body.appendChild(title);

    var price = document.createElement('div');
    price.className = 'bw-wish-card__price';
    price.textContent = formatMoney(product.price);
    if (product.compare_at_price > product.price) {
      var mrp = document.createElement('s');
      mrp.textContent = formatMoney(product.compare_at_price);
      price.appendChild(document.createTextNode(' '));
      price.appendChild(mrp);
    }
    body.appendChild(price);

    var actions = document.createElement('div');
    actions.className = 'bw-wish-card__actions';

    var variant = null;
    for (var i = 0; i < (product.variants || []).length; i++) {
      if (product.variants[i].available) { variant = product.variants[i]; break; }
    }

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'bw-wish-card__add';
    if (variant) {
      addBtn.textContent = 'Add to Cart';
      addBtn.addEventListener('click', function () {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function () { addBtn.textContent = 'Added ✓'; })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          });
      });
    } else {
      addBtn.textContent = 'Sold out';
      addBtn.disabled = true;
    }
    actions.appendChild(addBtn);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'bw-wish-card__remove';
    removeBtn.textContent = 'Remove';
    removeBtn.addEventListener('click', function () {
      saved().remove('wishlist', handle);
      card.remove();
      toggleEmptyState();
    });
    actions.appendChild(removeBtn);

    body.appendChild(actions);
    card.appendChild(body);
    return card;
  }

  function toggleEmptyState() {
    var empty = document.querySelector('[data-bw-wishlist-empty]');
    if (!empty) return;
    empty.hidden = saved().list('wishlist').length > 0;
  }

  function initPage() {
    var host = document.querySelector('[data-bw-wishlist-page]');
    if (!host) return;
    host.textContent = '';

    var entries = saved().list('wishlist');
    toggleEmptyState();
    if (!entries.length) return;

    var grid = document.createElement('div');
    grid.className = 'bw-wish-grid';
    host.appendChild(grid);

    entries.forEach(function (entry) {
      fetchProduct(entry.handle).then(function (product) {
        if (product) grid.appendChild(buildWishCard(product, entry.handle));
        toggleEmptyState();
      });
    });
  }

  function start() {
    if (!saved()) return; /* storage core failed to load — do nothing */
    injectCardHearts();
    watchForCards();
    initPdpButtons();
    initPage();
  }

  window.BWWishlistUI = { injectCardHearts: injectCardHearts, initPage: initPage };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
